// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"review_mainContainer__2NbpM","commonItemStyles":"review_commonItemStyles__5hj7g","ReviewAuthor":"review_ReviewAuthor__1B-Fl"};